import React, { useContext, useState } from "react";
import SignUp from "../component/signUp";
import Login from "../component/login";
import Background from "../assesets/Gadvasu_bg.jpg";
import Logo from "../assesets/logo.png";
import FormContext from "../context/formContext";
import { useEffect } from "react";

function LoginSignup() {


  const context = useContext(FormContext);
  const { showform, setShowform } = context;
  // const [isFormEnable, setIsFormEnable] = useState();
  const [isFormEnable, setIsFormEnable] = useState(false); 
  const [formMessage, setFormMessage] = useState("");
  const [isWithinDateRange, setIsWithinDateRange] = useState(""); 

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      db_name: "erp_eshiksa",
      // Branch_id: "1729",
      Branch_id: "2244",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/checkifformisdisabled.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) =>{ 
        var responseData = JSON.parse(result);
        console.log(responseData);
        // eslint-disable-next-line 
         //newcode
       
         const formattedFromDate = responseData?.data?.from_date || null;
         const formattedToDate = responseData?.data?.to_date || null;
        const formattedMsg = responseData.msg || null; 

       //  const formattedFromDate = "2024-08-12 15:25:00";
       //  const formattedToDate = "2024-08-12 23:59:00";
       //  const formattedMsg =  responseData.msg ;
       // const formattedMsg = "Form Is Disabled.";

       const fromDate = formattedFromDate;
       const toDate = formattedToDate;
       const currentDate = new Date();

       const formattedDate = `${currentDate.getFullYear()}-${String(
         currentDate.getMonth() + 1
       ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
         2,
         "0"
       )} ${String(currentDate.getHours()).padStart(2, "0")}:${String(
         currentDate.getMinutes()
       ).padStart(2, "0")}:${String(currentDate.getSeconds()).padStart(
         2,
         "0"
       )}`;

       const isWithinDateRange =
         formattedDate >= fromDate && formattedDate <= toDate;
       const isFormDisabledByMsg = formattedMsg === "Form Is Disabled.";

       // Update the state based on conditions
       setFormMessage(formattedMsg);
       setIsWithinDateRange(isWithinDateRange);

       setIsFormEnable(
         (formattedMsg === "Form Is Enable." || (!fromDate && !toDate)) &&
           !isFormDisabledByMsg &&
           !isWithinDateRange // Disable form if within date range
       );
         // newcodeend
        // if(responseData.success = 1){
        //   setIsFormEnable(responseData.isFormEnable);
        // }

      })
      .catch((error) => console.log("error", error));
  }, []);


 

  const redirectUrl1 = () => {
    // window.open(
    //   "https://www.gadvasu.in/page/important-revised-schedule-admission-2024-25",
    //   "_blank"
    // );
    window.open(
          "https://erp.eshiksa.net/DirectFeesv3/assets/img/gadvasu/Important_Information_2025-26.pdf",
          "_blank"
    );
  };

  const redirectUrl2 = () => {
    window.open(
      //"https://www.gadvasu.in/assests/uploads/images/GADVASU%20Prospectus%202023-24.pdf",
      // "https://www.gadvasu.in/assests/uploads/images/gadvasu%20Prospectus%202024-25_compressed.pdf",
      "https://erp.eshiksa.net/DirectFeesv3/assets/img/gadvasu/Prospectus_2025-26.pdf",
      "_blank"
    );
  };

  const redirectUrl3 = () => {
    window.open(
      // "https://www.mygetepay.com/GADVASU_online_application_procedure_2024_25_Final_changes.pdf",
      "https://erp.eshiksa.net/DirectFeesv3/assets/img/gadvasu/Procedure_to_fill_online_application_form.pdf",
      "_blank"
    );
  };

  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        backgroundSize: "cover",
        height: "100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="w-100"
    >
      <div className="mt-lg-5 mt-md-2 my-2 mx-2 position-absolute">
        <button className="btn btn-md button_back" onClick={redirectUrl3}>
          Procedure to fill Online Application
        </button>
      </div>
      <section className="py-5 d-flex justify-content-between">
        <div
          className="card mx-auto"
          style={{
            height: "700px",
            width: "350px",
            backgroundColor: "#ffffffc4",
          }}
        >
          <div className="w-100 d-flex justify-content-center p-2">
            <img src={Logo} alt="" style={{ width: "25%" }} />
          </div>
          <h6 className="text-center">Year 2025-26</h6>
          <div className="card-body">
            <ul className="nav nav-tabs justify-content-center">
              <li className="nav-item">
                {/* <button
                  className="nav-link text_color"
                  aria-current="page"
                  onClick={() => setShowform(true)}
                  disabled = {!isFormEnable}
                >
                  Sign Up
                </button> */}

                <button
                  className="nav-link text_color"
                  aria-current="page"
                  onClick={() => setShowform(true)}
                  disabled={
                    (formMessage === "Form Is Disabled." &&
                      isWithinDateRange) || 
                    (formMessage === "Form Is Enable." && !isWithinDateRange) 
                  }
                >
                  Sign Up
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link text_color"
                  onClick={() => setShowform(false)}
                >
                  Login
                </button>
              </li>
            </ul>
            {showform ? <SignUp /> : <Login />}
          </div>
        </div>
      </section>

      <div className="container-fluid bg-primary p-3">
        <div className="d-flex justify-content-around flex-wrap">
          <div>
            <button
              className="btn btn-md button_back my-2"
              onClick={redirectUrl1}
            >
              Important Updates
            </button>
          </div>
          <div>
            <button className="btn btn-md button_back my-2">
              Diploma-Prospectus 2025-26
            </button>
          </div>
          <div>
            <button
              className="btn btn-md button_back my-2"
              onClick={redirectUrl2}
            >
              University-Prospectus 2025-26
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginSignup;
